import React from "react";
import styles from "./FullProfile.module.css";

export default function PeopleLiaisons({ data }) {
  return (
    <div className={styles.profileData}>
      <h3>
        People & <span>Liaisons</span>
      </h3>
      <div>
        {data &&
          data.about &&
          data.about.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
      </div>
    </div>
  );
}
